import { Injectable, EventEmitter } from '@angular/core';
import { SuccessConfirmationCode } from '../../enums/success-confirmation-code.enum';
import { ApplicantDetails } from '../../models/applicant-details';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Language } from '../../enums/language.enum';
import { ReturnURLKey } from '../../enums/return-url-key.enum';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  currentUser: ApplicantDetails;
  baseUrl: string;
  public isUserReady: boolean;
  public isUserReadyEventEmitter: EventEmitter<any>;
  private isLoaderHidden: boolean;

  constructor(private http: HttpClient) {
    this.getCurrentUser();
    this.isLoaderHidden = false;
    this.baseUrl = this.getBaseUrl();
    this.isUserReady = false;
    this.isUserReadyEventEmitter = new EventEmitter<any>();
  }


  public  getCurrentUser() {
    this.http.get<ApplicantDetails>(environment.getCurrentUser).subscribe(result => {
      this.currentUser = result;
      this.isUserReady = true;
      this.isUserReadyEventEmitter.emit();
    });
  }


  private getBaseUrl(): string {
    return window.location.href.toLowerCase().split('services/forms')[0];
  }


  public showLoader(): void {
    document.querySelector('#eservices-site-loader').classList.remove('done');
    document.querySelector('html').classList.add('unscrollable');
    document.querySelector('body').classList.add('unscrollable');
    this.isLoaderHidden = false;
  }

  public hideLoader(): void {
    document.querySelector('#eservices-site-loader').classList.add('done');
    document.querySelector('html').classList.remove('unscrollable');
    document.querySelector('body').classList.remove('unscrollable');
    this.isLoaderHidden = true;
  }

  public getUrlParams(prop?: string): any {
    var params = {};
    var search = decodeURIComponent(window.location.href.toLowerCase().slice(window.location.href.indexOf('?') + 1));
    var definitions = search.split('&');

    definitions.forEach(function (val, key) {
      var parts = val.split('=', 2);
      params[parts[0]] = parts[1];
    });
    return (prop && prop in params) ? params[prop] : params;
  }

  public redirectToSuccessPage(applicationNumber?: any, messageCode?: SuccessConfirmationCode, referenceId?: any, taskId?: any): void {
   
    let url = `${this.baseUrl}${environment.successPage}?`;
    
    if (applicationNumber)
      url += `applicationNumber=${applicationNumber}`;
    if (taskId)
      url += `&taskId=${taskId}`;
    if (messageCode)
      url += `&messageCode=${messageCode}`;
    if (referenceId)
      url += `&applicationReferenceId=${referenceId}`;
    var urlParams = this.getUrlParams();
    if (urlParams["ismobile"] == "true") {
      url += "&IsMobile=true"
    }
    if (urlParams["mobileos"] != null && urlParams["mobileos"] != "undefined") {
      url += "&MobileOS=" + urlParams["mobileos"]
    }
    window.location.href = url;
  }
  public redirectToAppointmentPage(applicationId?: any,taskId?: any): void {
    let url = `${this.baseUrl}${environment.appointmentPage}?`;
    if (applicationId)
      url += `AttestationId=${applicationId}`;
    if (taskId)
      url += `&AttestationTaskId=${taskId}`;
    var urlParams = this.getUrlParams();
    if (urlParams["ismobile"] == "true") {
      url += "&IsMobile=true"
    }
    if (urlParams["mobileos"] != null && urlParams["mobileos"] != "undefined") {
      url += "&MobileOS=" + urlParams["mobileos"]
    }
    window.location.href = url;
  }
  public redirectToAttachmentsPage(serviceURL:string , applicationId?: any, taskId?: any): void {
    let url = `${this.baseUrl}${environment.serviceBase}${serviceURL}?`;
    if (taskId)
      url += `taskId=${taskId}`;
    if (applicationId)
      url += `&applicationid=${applicationId}`;
    var urlParams = this.getUrlParams();
    if (urlParams["ismobile"] == "true") {
      url += "&IsMobile=true"
    }
    if (urlParams["mobileos"] != null && urlParams["mobileos"] != "undefined") {
      url += "&MobileOS=" + urlParams["mobileos"]
    }
    window.location.href = url;
  }
  public redirectToPaymentPage(applicationId?: any, taskId?: any): void {
    let url = `${this.baseUrl}${environment.paymentPage}?`;
    if (taskId)
      url += `taskId=${taskId}`;
    if (applicationId)
      url += `&applicationid=${applicationId}`;
    var urlParams = this.getUrlParams();
    if (urlParams["ismobile"] == "true") {
      url += "&IsMobile=true"
    }
    if (urlParams["mobileos"] != null && urlParams["mobileos"] != "undefined") {
      url += "&MobileOS=" + urlParams["mobileos"]
    }
    window.location.href = url;
  }
  public backToWorkSpace(workSpace?: string) {
    if (workSpace) {
      window.location.href = window.location.href.toLowerCase().split('/forms/')[0] + "/forms/" + workSpace;
    }
    else {
      window.location.href = window.location.href.toLowerCase().split('/forms/')[0] + "/forms/" + this.checkUserWorkSpaceURL();
    }
  }
  public back(applicationId: string, language: Language) {
    let urlKey = this.getUrlParams()["returnurlkey"];
    //let enumKey:ReturnURLKey= <any>ReturnURLKey[urlKey];
    if (urlKey) {
      switch (+urlKey) {
        case ReturnURLKey.MyWorkspace: {
          this.backToWorkSpace("My-Workspace");
          break;
        }
        case ReturnURLKey.EmployeeWorkspace: {
          this.backToWorkSpace("EmployeeWorkspace");
          break;
        }
        case ReturnURLKey.DeparmentHeadWorkspace: {
          this.backToWorkSpace("DeparmentHeadWorkspace");
          break;
        }
        case ReturnURLKey.NationalAffairsWorkspace: {
          this.backToWorkSpace("NationalAffairsWorkspace");
          break;
        }
        case ReturnURLKey.TawajudiWorkspace: {
          this.backToWorkSpace("TawajudiWorkspace");
          break;
        }
        case ReturnURLKey.NotFoundItemsList: {
          this.backToWorkSpace("Not-Found-Items-List");
          break;
        }
        case ReturnURLKey.TwajudiResidentsWorkspace: {
          this.backToWorkSpace("Twajudi-Residents-Workspace");
          break;
        }
        default: {
          this.backToWorkSpace();
          break;
        }
      }
     
    }
    else {
      console.log(this.getBaseUrl())
      if (applicationId && applicationId != "")
        this.backToWorkSpace();
      else {
        if (language == Language.Arabic)
          window.location.href = window.location.href.toLowerCase().split('/services/forms')[0] + "/services/";
        else
          window.location.href = window.location.href.toLowerCase().split('/services/forms')[0] + "/services/";

      }
    }
      
  }
  private checkUserWorkSpaceURL(): string {
    if (this.currentUser.Roles.toLowerCase() == "extranet\\organization user")
      return "OrganizationAdminWorkspace";
    else if (this.currentUser.Roles.indexOf("MOFAIC\\TwajudiResidents") > -1)
      return "twajudi-residents-workspace";
    else if (!this.currentUser.IsBackEndUser)
      return "My-Workspace";
    //else if (this.currentUser.Roles === "MOFAIC\\Mission Officers")
    //  return "TawajudiWorkspace";
    //else if (this.currentUser["Roles"] == "MOFAIC\\CRM Users")
    //  return "CRMWorkspace"
    else if (this.currentUser.Roles === "MOFAIC\\Department Head")
      return "DeparmentHeadWorkspace";
   
    else
      return "EmployeeWorkspace";
  }


  public sendToken(email: string) {
    return this.http.get<boolean>(`${environment.sendToken}?email=${email}`);
  }


}
